export default __webpack_public_path__ + "static/media/Measure.32492acc.png";